import * as tippy from "tippy.js";
import { ewent } from "../../../lib/reactive";
import { C } from "../../../lib/ui/constructors";
import jquery from "jquery";
var hbox = C.hbox;
var span = C.span;
var spacer = C.spacer;
export function rend(s) {
    if (typeof s == "string")
        return s;
    else
        return s();
}
var open_menu;
(function (open_menu) {
    var cls = C.cls;
    function init(menu) {
        let r = {
            cancelled: ewent(),
            closed: ewent(),
            menu: menu,
            root_page: null
        };
        menu.children.push({
            type: "basic",
            text: "Cancel",
            handler: () => cancel(r)
        });
        r.root_page = render(menu, null, r);
        r.root_page.root_widget.container.on("keydown", (e) => {
            if (e.key == "Escape") {
                e.stopPropagation();
                cancel(r);
            }
            let current = deepest(r);
            if (e.key == "ArrowRight") {
                if (current.highlight != null && current.underlying.children[current.highlight].type == "submenu") {
                    confirm(current);
                }
            }
            if (e.key == "ArrowLeft") {
                if (current.parent)
                    close(current);
                // TODO: If any sub menu is open, close it
            }
            if (e.key == "ArrowUp") {
                open_menu.highlight(current, current.highlight != null ? (current.highlight - 1 + current.underlying.children.length) % current.underlying.children.length : current.underlying.children.length - 1);
            }
            if (e.key == "ArrowDown") {
                open_menu.highlight(current, current.highlight != null ? (current.highlight + 1) % current.underlying.children.length : 0);
            }
            if (e.key == "Enter") {
                confirm(current);
            }
        });
        return r;
    }
    open_menu.init = init;
    function close(menu) {
        if (!menu)
            return;
        if (menu.open_child)
            close(menu.open_child);
        if (menu.tippy_instance) {
            menu.tippy_instance.destroy();
            menu.tippy_instance = null;
            menu.root_widget.remove();
            if (menu.parent)
                menu.parent.open_child = null;
            else
                menu.root.root_page = null;
        }
    }
    open_menu.close = close;
    function cancel(menu) {
        if (!menu.option_selected)
            menu.cancelled.trigger(menu);
        menu.closed.trigger(menu);
        close(menu.root_page);
    }
    open_menu.cancel = cancel;
    function confirm(menu, i = null) {
        if (i != null && i != menu.highlight)
            highlight(menu, i);
        if (menu.highlight != null) {
            let e = menu.underlying.children[menu.highlight];
            if (e.type == "basic") {
                menu.root.option_selected = true;
                e.handler();
                cancel(menu.root);
            }
            else {
                openSubmenu(menu);
                highlight(menu.open_child, 0);
            }
        }
    }
    open_menu.confirm = confirm;
    function render(menu, parent, root) {
        let m = {
            root: root,
            parent: parent,
            underlying: menu,
            root_widget: cls("nisl-context-menu")
                .tapRaw(j => j
                //.on("click", (e) => e.stopPropagation())
                .attr("tabindex", "0")),
            rows: null,
            tippy_instance: null,
            highlight: null,
            open_child: null
        };
        // TODO: Icon?
        if (!parent)
            cls("nisl-context-menu-header")
                .append(menu.text ? rend(menu.text) : "Choose Option")
                .appendTo(m.root_widget);
        let with_icon = menu.children.some(e => !!e.icon);
        m.rows = menu.children.map((entry, i) => {
            return hbox(with_icon
                ? c("<div class='nisl-context-menu-entry-icon-container'></div>")
                    .append(entry.icon
                    ? (typeof entry.icon == "string" ? c(`<img src="${entry.icon}">`) : entry.icon())
                    : null)
                : null, rend(entry.text), spacer().css("min-width", "10px"), entry.type == "submenu" ? span().setInnerHtml("&#x276F;") : null).addClass("nisl-context-menu-entry")
                .tapRaw(r => r
                .on("click", (e) => {
                e.stopPropagation();
                confirm(m, i);
            })
                .on("mouseover", () => {
                highlight(m, i);
                openSubmenu(m);
            }));
        });
        m.root_widget.append(...m.rows);
        return m;
    }
    open_menu.render = render;
    function highlight(men, i) {
        if (i == men.highlight)
            return;
        if (men.open_child)
            close(men.open_child);
        if (men.highlight != null) {
            men.rows[men.highlight].toggleClass("nisl-context-menu-entry-selected", false);
            men.highlight = null;
        }
        if (i != null) {
            men.rows[i].toggleClass("nisl-context-menu-entry-selected", true);
            men.highlight = i;
        }
    }
    open_menu.highlight = highlight;
    function deepest(menu_root) {
        let men = menu_root.root_page;
        while (men?.open_child)
            men = men.open_child;
        return men;
    }
    open_menu.deepest = deepest;
    function openSubmenu(men) {
        if (men.highlight == null)
            return;
        let e = men.underlying.children[men.highlight];
        if (e.type != "submenu")
            return;
        close(men.open_child);
        men.open_child = render(e, men, men.root);
        show(men.open_child, men.rows[men.highlight].raw(), null);
    }
    open_menu.openSubmenu = openSubmenu;
    function show(men, dom_parent, position) {
        const nested = jquery(dom_parent).is(".tippy-content *");
        men.tippy_instance =
            tippy.default(dom_parent, {
                placement: 'right-start',
                trigger: 'manual',
                interactive: true,
                arrow: false,
                offset: [0, 0],
                animation: false,
                interactiveBorder: 20,
                interactiveDebounce: 0.5,
                content: men.root_widget.raw(),
                maxWidth: "none",
                zIndex: 10001,
                appendTo: nested ? "parent" : document.body
            });
        if (!men.parent) {
            men.tippy_instance.setProps({
                onHidden: () => cancel(men.root),
                onMount: () => men.root.root_page.root_widget.raw().focus(),
            });
        }
        if (position)
            men.tippy_instance.setProps({
                getReferenceClientRect: () => ({
                    width: 0,
                    height: 0,
                    top: position.y,
                    bottom: position.y,
                    left: position.x,
                    right: position.x,
                }) /* typing of tippy is terrible*/
            });
        men.tippy_instance.show();
    }
    open_menu.show = show;
})(open_menu || (open_menu = {}));
export default class ContextMenu {
    constructor(menu) {
        this.menu = menu;
        this.openMenuTree = null;
        if (this.openMenuTree) {
            open_menu.cancel(this.openMenuTree);
            this.openMenuTree = null;
        }
        this.openMenuTree = open_menu.init(this.menu);
    }
    showFromEvent(e) {
        return this.showFromEvent2(e.originalEvent);
    }
    showFromEvent2(e) {
        return this.show(e.target, { x: e.clientX, y: e.clientY });
    }
    show(target, position) {
        open_menu.show(this.openMenuTree.root_page, target, position);
        return this;
    }
    onCancel(f) {
        this.openMenuTree.cancelled.on(f);
        return this;
    }
    onClosed(f) {
        this.openMenuTree.closed.on(f);
        return this;
    }
}
